define('CustomerOrderSurcharge.Model',
  [
    'SCModel',
    'Utils'
  ],
  function (
    SCModelComponent,
    Utils
  ) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    function CustomerOrderSurchargeModel() {
      SCModel.call(this);

      this.urlRoot = function urlRoot() {
        return Utils.getAbsoluteUrl(
          getExtensionAssetsPath('Modules/CustomerOrderSurcharge/SuiteScript2/CustomerOrderSurcharge.Service.ss'),
          true
        );
      };
    }

    CustomerOrderSurchargeModel.prototype = Object.create(SCModel.prototype);
    CustomerOrderSurchargeModel.prototype.constructor = CustomerOrderSurchargeModel;

    return CustomerOrderSurchargeModel;
  });
